import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`

  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const PictureStyled = styled.img`
  width: ${props => props.width}px;
  height: auto;
  animation: ${fadeIn} .2s ease-in;
`;

class Picture extends React.Component {
  static defaultProps = {
    width: 200,
  }

  static propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    width: PropTypes.number,
  }
  render() {
    const { src, alt } = this.props;
    return (
      <PictureStyled
        src={src}
        alt={alt}
        {...this.props}
      />
    );
  }
}

export default Picture;
